import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootBody: {
        width: '400px',
        background: 'white',
        boxShadow: '0px 14px 80px rgba(34, 35, 58, 0.2)',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    rootHeader: {
        background: 'white',
        width: '100%',
        padding: '12px 15px',
        textDecoration: 'none',
        fontSize: '12px',
        borderTopRightRadius: '5px',
        borderTopLeftRadius: '5px',
        boxShadow: '0px -0.1px 0.5px 0px grey',
    },
    rootTitle: {
        fontFamily: themeCommon.RobotoBold,
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    rootQuantityContain: {
        width: themeCommon.fontSize20px,
        height: themeCommon.fontSize20px,
        borderRadius: '50%',
        background: themeCommon.bg_number,
        marginLeft: '8px',
        [theme.breakpoints.down('xs')]: {
            width: themeCommon.fontSize18px,
            height: themeCommon.fontSize18px,
        },
    },
    rootQuantityUnder: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        right: '5px',
        top: '8px',
        position: 'absolute',
        fontSize: '11px',
        width: '17px',
        height: '17px',
        borderRadius: '50%',
        background: '#DC5423',
    },
    rootQuantity: {
        fontSize: '13px',
        color: 'white',
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootContain: {
        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    },
    rootIcon: {
        color: '#FFFFFF',
    },
    paperContain: {
        overflowY: 'hidden',
        borderBottomRightRadius: '5px',
        borderBottomLeftRadius: '5px',
        '&:hover': {
          overflowY: 'auto',
        },
    },
    rootGridContainerIcon: {
        '& > div > a': {
            textDecoration: 'none',
        },
    },
    containerIcon: {
        width: '24px',
        height: '24px',
        color: 'black',
    },
    rootLink: {
        color: 'black',
        fontSize: '1rem',
        '&:hover': {
            textDecoration: 'none',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    rootList: {
        width: '100%',
        paddingTop: '15px',
        height: '300px',
        overflow: 'scroll',
        background: '#f1f1f1',
        [theme.breakpoints.down('sm')]: {
            height: '200px',
        }
    },
    conainerShowMore: {
        width: '100%',
        padding: '10px'
    },
    buttonShowMore: {
        cursor: 'pointer',
        color: '#098EAC',
    },
}), {
    name: 'NofiticationPopoverHeadContainer',
    index: 1,
})

export default useStyles